import React from 'react';
import className from '@search/classname/src';
import { YMapPanorama, IYMapPanoramaProps } from '@search/ymap/src/Panorama';

import './styles.css';

const cn = className.bind(null, 'YMapPanoramaDesktop');

export const YMapPanoramaDesktop = (props: IYMapPanoramaProps) => (
    <div className={cn()}>
        <YMapPanorama
            closeButtonEnabled
            {...props}
        />
    </div>
);
